import { Capacitor } from '@capacitor/core';
import { readIncomingAppUrl } from '../shared/appLinks';
import { isVendorInviteUrl } from '../shared/vendorInviteLink';
import { LEGAL_ENTRY_STATE, legalPageFromPath } from './legal';

export const APP_URL_EVENT = 'pacarion-app-url';

export function applyIncomingAppUrl(rawUrl) {
  if (typeof window === 'undefined' || !rawUrl) return null;
  // Vendor invites stay in Safari. The native delegate opens them there.
  if (isVendorInviteUrl(rawUrl)) return null;
  let parsed;
  try {
    parsed = new URL(rawUrl);
  } catch (error) {
    return null;
  }
  const host = parsed.hostname.replace(/^www\./, '');
  if (host !== 'app.pacarion.com' && host !== 'localhost') return null;
  const next = `${parsed.pathname || '/'}${parsed.search || ''}${parsed.hash || ''}`;
  const state = legalPageFromPath(parsed.pathname) ? { [LEGAL_ENTRY_STATE]: true } : {};
  window.history.pushState(state, '', next);
  const detail = readIncomingAppUrl(next);
  window.dispatchEvent(new PopStateEvent('popstate'));
  window.dispatchEvent(new CustomEvent(APP_URL_EVENT, { detail }));
  return detail;
}

export async function installUniversalLinks() {
  if (!Capacitor.isNativePlatform()) return () => {};
  try {
    const { App } = await import('@capacitor/app');
    const handle = await App.addListener('appUrlOpen', (event) => {
      if (!event || !event.url || isVendorInviteUrl(event.url)) return;
      applyIncomingAppUrl(event.url);
    });
    return () => {
      if (handle && handle.remove) handle.remove();
    };
  } catch (error) {
    return () => {};
  }
}
